import type React from "react";

export type GenericTableRow = { id: string | number } & Record<string, unknown>;

export const renderTableCellValue = (value: unknown): React.ReactNode => {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return value;
  }
  return null;
};

export const toComparableString = (value: unknown): string => {
  if (typeof value === "string") {
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return "";
};
